/**
 * Menubar real-estate can be sparse. This fucntion will remove (via Clockwise) if present,
 * truncate the title to a max of 12 characters, and add an ellipsis if the title is longer than 12 characters.
 * @param unprocessed string. Full meeting name.
 * @param maxLength number
 * @returns
 */
export const getMenuBarText = (unprocessed: string, maxLength = 14) => {
  const processed = unprocessed.replace(" (via Clockwise)", "").trim();

  if (
    ["Focus Time", "Lunch", "Travel Time", "Busy", "Break"].includes(
      processed.replace("❇️", "").trim(),
    )
  ) {
    return processed;
  }

  // Truncate to either max length or last space before max length.
  const lastSpaceIndex = processed.lastIndexOf(" ", maxLength);
  let finalTruncation = processed
    .substring(0, lastSpaceIndex === -1 ? maxLength : Math.max(lastSpaceIndex, maxLength - 2))
    .trim();
  if (finalTruncation.length < processed.length) {
    finalTruncation += "..";
  }
  return finalTruncation;
};
